import { FHWEndpoints } from '../react/model/global';

export const endpointStub = 'path:/o-fhw-search/';
export const endpoint: Record<FHWEndpoints, string> = {
	getResults: 'getResults',
	getLocationSuggestions: 'getLocationSuggestions',
	getPartnerProfile: 'getPartnerProfile',
};
